import axios from 'axios'
import session from 'vue-cookies'
var BASE_URL = "https://api.bertiebets.com/configuration"
var key = session.get('bertiebets.admin.key')
export async function getPredictionSettings() {
  key = session.get('bertiebets.admin.key')
  var url = BASE_URL + "/prediction-settings"
  var response = await axios.get(url, {headers:{'x-api-key' : key}})
  return response
}
